import { render, staticRenderFns } from "./page-navigate.vue?vue&type=template&id=f68fe618&scoped=true&"
import script from "./page-navigate.vue?vue&type=script&lang=js&"
export * from "./page-navigate.vue?vue&type=script&lang=js&"
import style0 from "./page-navigate.vue?vue&type=style&index=0&id=f68fe618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68fe618",
  null
  
)

export default component.exports